import type { IChatBoxListScroller } from "./chat-box-list-scroller.interface";

export class ChatBoxListScroller implements IChatBoxListScroller {
	private container_: HTMLDivElement | null;
	public constructor() {
		this.container_ = null;
	}

	public get domElement(): HTMLDivElement | null {
		console.log("dongmt get domElement: ", this.container_);
		return this.container_;
	}

	public bindScrollableContainer(container: HTMLDivElement | null): void {
		this.container_ = container;
		console.log("dongmt bindScrollableContainer: ", this.container_);
	}

	public scrollToBottom(): void {
		if (!this.container_) return;
		this.container_.scrollTop = this.container_.scrollHeight;
	}

	public scrollToTop(): void {
		if (!this.container_) return;
		this.container_.scrollTop = 0;
	}

	public get scrollTop(): number {
		if (!this.container_) return 0;
		return this.container_.scrollTop;
	}

	public set scrollTop(value: number) {
		if (!this.container_) return;
		this.container_.scrollTop = value;
	}

	public get scrollHeight(): number {
		if (!this.container_) return 0;
		return this.container_.scrollHeight;
	}

	public dispose(): void {
		// this.container_ = null;
	}
}
